import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { NgClass } from '@angular/common';
import { SignaturePadComponent } from '~ngx-shared/formly/components/signature-pad/signature-pad.component';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface SignaturePadProps extends FieldWrapperProps {}

export interface SignaturePadFieldConfig extends FormlyFieldConfig<SignaturePadProps> {
  type?: 'signature-pad' | Type<SignaturePadTypeComponent>;
}

@Component({
  selector: 'lib-formly-signature-pad-type',
  styleUrl: './signature-pad-type.component.css',
  templateUrl: './signature-pad-type.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, FormlyModule, NgClass, SignaturePadComponent]
})
export class SignaturePadTypeComponent extends FieldType<FieldTypeConfig<SignaturePadProps>> {}
